module.exports = __webpack_public_path__ + "images/patterns/pattern-light_ff69a6fd14bf4770b36a8880bf53dda8.svg";